const state = {
	user: null
}

const getters = {
	loggedIn: state => state.user !== null,
	username: state => state.user && state.user.username,
	isAdmin: state => state.user && state.user.role.type === 'administrator'
}

const mutations = {
	logIn(state, { user }) {
		state.user = user
	},
	logOut(state) {
		state.user = null
	}
}

const actions = {
	async check({ commit, dispatch }) {
		// Fetch user details on load
		try {
			const user = await dispatch(
				'api/get',
				{ endpoint: '/users/me' },
				{ root: true }
			).then(res => res.json())

			// Commit user data to store
			commit('logIn', { user })
			return true
		} catch (err) {
			commit('logOut')
			return false
		}
	},
	async logIn({ commit, dispatch }, creds) {
		try {
			// Log in via API
			const res = await dispatch(
				'api/post',
				{ endpoint: '/auth/local', body: JSON.stringify(creds) },
				{ root: true }
			).then(res => res.json())

			// Commit user data to store
			commit('logIn', res)
			return true
		} catch (err) {
			return false
		}
	},
	async logOut({ commit, dispatch }) {
		// @TODO may have to call API endpoint to log out properly now
		try {
			await dispatch('api/get', { endpoint: '/auth/logout' }, { root: true })
			commit('logOut')
			dispatch(
				'toast/push',
				{ message: 'You were logged out successfully.' },
				{ root: true }
			)
			return true
		} catch (err) {
			return false
		}
	}
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
}
